import React from 'react'
import classnames from 'classnames'
import { image } from 'services'
import config from 'config'
import { IonIcon, MaterialIcon } from 'controls'

const COMPANY_SHOP_URL = config('COMPANY_SHOP_URL')
import {
  NEXI_CREDITO_URL,
  HESTIA_URL,
  MY_PROPERTIES_URL,
  MAILCOW_SSO_URL,
  HIGH_LEVEL_URL,
} from 'services/config'

export const NexiShopLink = ({ hideOnMobile, hideTextOnMobile = false }) => (
  <a
    style={{ display: 'flex', flexWrap: 'wrap' }}
    className={classnames({ hideOnMobile }, { 'hide-text-on-mobile': hideTextOnMobile })}
    href={COMPANY_SHOP_URL}
    target="_blank"
  >
    <img
      src={image('/icons/nexi-tienda.svg')}
      alt="Nexi-tienda"
      style={{ marginRight: '0.7rem', maxWidth: '1.1rem' }}
    />
    <span>Nexitienda</span>
  </a>
)

export const HestiaLink = ({ hideOnMobile, hideIconOnMobile }) => (
  <a
    style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}
    className={classnames({ hideOnMobile }, 'hide-text-on-mobile')}
    href="https://www.hestiaplp.com.mx"
    target="_blank" rel="noreferrer"
  >
    <img
      src={image('/icons/cookie-hestia.svg')}
      alt="Hestia"
      className={classnames({ hideOnMobile: hideIconOnMobile })}
      style={{ marginRight: '0.7rem', maxWidth: '1rem' }}
    />
    <span>Póliza Hestia</span>
  </a>
)


export const NexicreditLink = ({ hideOnMobile, hideIconOnMobile, hideTextOnMobile = false }) => (
  <a
    style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}
    className={classnames({ hideOnMobile }, { 'hide-text-on-mobile': hideTextOnMobile })}
    href={NEXI_CREDITO_URL}
    target="_blank" rel="noreferrer"
  >
    <img
      src={image('/icons/icon-nexicredito.svg')}
      alt="Nexicrédito"
      className={classnames({ hideOnMobile: hideIconOnMobile, color: 'gray' })}
      style={{ marginRight: '0.7rem', maxWidth: '2rem' }}
    />
    <span>Nexicrédito</span>
  </a>
)

export const SogoEmailLink = ({ hideTextOnMobile = false }) => (
  <a
    style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}
    className={classnames({ 'hide-text-on-mobile': hideTextOnMobile })}
    href={MAILCOW_SSO_URL}
    target="_blank" rel="noreferrer"
  >
    <IonIcon size="small" icon="md-mail-open" style={{ marginRight: '0.5rem' }} />
    <span>Correo</span>
  </a>
)

export const CrmHighLevelLink = ({ hideOnMobile, hideTextOnMobile = false }) => (
  <a
    style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}
    className={classnames({ hideOnMobile }, { 'hide-text-on-mobile': hideTextOnMobile })}
    href={HIGH_LEVEL_URL}
  >
    <MaterialIcon
      icon="monitor"
      style={{ marginRight: '0.5rem' }}
      />

    <span>CRM</span>
  </a>
)
